import React from 'react';

import './Loading.scss';

const Loading: React.FC = () => {
  return (
    <div className="psf-spinner-container">
      <div className="psf-loading-spinner"></div>
    </div>
  );
};

export default Loading;
